import * as l from "react";
const e = (a) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M16.165 2.912a10 10 0 015.815 9.818h-.01c-.25-.22-.56-.4-.92-.54L20 11.8a8 8 0 10-8.2 8.2l.4 1.06c.12.36.3.67.53.92a10 10 0 113.435-19.068zM12.35 11.06l8 3a1 1 0 01-.1 1.91l-2.3.57h.01l3.75 3.75a1.004 1.004 0 11-1.42 1.42l-3.75-3.75-.57 2.28a1 1 0 01-1.9.11l-3-8a1 1 0 011.28-1.29zm5.57-.04l-2.39-.9a4 4 0 10-5.41 5.41l.9 2.39a6 6 0 116.9-6.9z",
      fill: "#2d6ded"
    }
  )
);
export {
  e as default
};
